import React from 'react';
import ReviewFromInvitation from '../../components/public/ReviewFromInvitation';
const InvitationsPage = () => {

    return (<>
      <ReviewFromInvitation />
    </>)
}
export default InvitationsPage